<template>
	<div id="chart" v-drag="{dragElSelector: '.dragtest',clickSelector:'.message-head'}">
		<div style="display:flex;height:100%;border:1px solid #999">
			<!-- 左侧工具栏 -->
			<div class="cardList">
				<div class="m-card">
					<!-- 头像 -->
					<header>
						<img class="avatars" width="40" height="40" :alt="user.name" :src="user.img" @click="editDialog">
					</header>
					<!-- 工具栏 -->
					<div class="foot">
						<el-badge :value="footmessagevalue" :hidden="footmessagevalue == 0 || footmessagevalue < 0">
							<img class="footmessage" :src="isFriend && !showset?require('@/assets/images/messagecolor.png'):require('@/assets/images/message.png')" alt="聊天" @click="getFriend">
						</el-badge>
						<el-badge :value="badge" :hidden="!badge">
							<img class="footpeople" :src="!isFriend && !showset?require('@/assets/images/peoplecolor.png'):require('@/assets/images/people.png')" alt="联系人" @click="showAdd">
						</el-badge>
						<img class="footset" :src="!showset?require('@/assets/images/set.png'):require('@/assets/images/setcolor.png')" alt="设置" @click="showset = true">
					</div>
				</div>
			</div>
			<!-- 右侧显示部分 -->
			<div style="width:96.5%" class="dragtest">
				<!-- 聊天会话模块 -->
				<chatsession 
					ref="chatsession"
					v-show="!isAdd && !showset"
					:isFriend="isFriend"
					:isemptyShow="isemptyShow"
					:showMemo="showMemo"
					:showFriendsList="showFriendsList"
					:user-list="userList" 
					:session="session" 
					:user="user"
					:session-index.sync="sessionIndex" 
					:search="search" 
					@emptyShow="emptyShow" 
					@updatebadge="$emit('updatebadge')"
					:choose="isFriend && !isemptyShow"
					@close="close"
					@hasNewFriend="badge ++"
					@updateMsg="FriendList" 
					@changebadge="changebadge"
					@toggleFullScreen="toggleFullScreen"
					@isRead="$emit('isRead')"></chatsession>
				<!-- 联系人模块 -->
				<TheContact 
					ref="TheContact"
					@trigger="trigger"
					v-show="isAdd && !showset"
					:session="session"
					:receiveData="receiveData"
					:isFriend="isFriend"
					:isemptyShow="isemptyShow"
					:showMemo="showMemo"
					:isAdd="isAdd"
					:showset="showset"
					:user-list="userList" 
					:showFriendsList="showFriendsList"
					@showFriends="showFriendsList = true"
					@chart="chart"
					@updatebadge="$emit('updatebadge')"
					@close="close"
					@toggleFullScreen="toggleFullScreen"
				></TheContact>
				<!-- 设置模块 -->
				<setting 
					v-show="showset"
					:session="session"
					:isFriend="isFriend"
					:isemptyShow="isemptyShow"
					@close="close"
					@toggleFullScreen="toggleFullScreen"
					:user-list="userList" ></setting>
			</div>
		</div>
		<!-- 基本信息修改弹框 -->
		<el-dialog 
			v-dialogDrag
			title="修改信息"
			:visible.sync="dialogVisible"
      width="30%"
      :modal="false">
      <el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="用户头像">
			    <el-upload
					  class="avatar-uploader"
					  action="https://jsonplaceholder.typicode.com/posts/"
					  :show-file-list="false"
						accept="image/*"
					  :http-request="handleAvatarSuccess"
						:before-upload="beforeAvatarUploadPdf">
					  <img v-if="form.headportrait" :src="form.headportrait" class="avatarImg">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
			  </el-form-item>
      	<el-form-item label="用户昵称">
			    <el-input v-model="form.usernickname" maxlength="20"></el-input>
			  </el-form-item>
			  <el-form-item label="真实姓名">
			    <el-input v-model="form.username" maxlength="20"></el-input>
			  </el-form-item>
			  <el-form-item label="联系方式">
			    <el-input v-model="form.phone" maxlength="20"></el-input>
			  </el-form-item>
			  <el-form-item label="备注">
			    <el-input v-model="form.memo" maxlength="20"></el-input>
			  </el-form-item>
      </el-form>
			<span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="edit" type="primary">确定修改</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import store from './store';
	// 聊天会话
	import chatsession from './ChatSession'
	import TheContact from './TheContact'
	import setting from './setting'
	import axios from '@/http/axios';

	export default {
		data() {
			let serverData = store.fetch();
			return {
				showset:false,
				footmessagevalue:0,
				memovalue:'',
				friendobj:null,
				showMemo:false,
				badge:0, // 新的好友标记数
				showFriendsList:false,
				dialogVisible:false,
				form:{
					username:'',
					usernickname:'',
					headportrait:serverData.user.img,
					phone:'',
					mobel:'',
					memo:''
				},
				file:'',
				isFriend:true,
				isAdd:false,
				receiveData:'',
				// 是否全屏
				isFullscreen:true,
				// 聊天框是否显示
				show: true,
				// 是否按下esc键
				isFull:null,
				// 登录用户
				user: serverData.user,
				// 用户列表
				userList: serverData.userList,
				// 会话列表
				sessionList: serverData.sessionList,
				// 搜索key
				search: {
					text: ''
				},
				// 选中的会话Index
				sessionIndex: {
					index: 0,
					id:''
				},
				userTableList:[],
				isemptyShow:true
			};
		},
		computed: {
			session() {
				return this.sessionList.length>0 ? this.sessionList[this.sessionIndex.index] : [];
			},
		},
		watch: {
			// 每当sessionList改变时，保存到localStorage中
			sessionList: {
				deep: true,
				handler(val) {
					this.sessionList = val;
				}
			},
			userList:{
				deep:true,
				handler(){
					this.footmessagevalue = eval(this.userList.map( x => x.unRead).join("+"))
				}
			}
		},
		components: {
			chatsession, // 聊天会话模块
			TheContact,
			setting
		},
		methods: {
		  // 发消息
			chart(friendobj){
				// 发消息
				this.isFriend = true;
				this.showMemo = false;
				this.isAdd = false
				this.getFriend()
				this.$refs.chatsession.$refs.list.select(this.userList.filter(x => x.id == friendobj.id)[0])
			},
			/**
			 *张俊娜：2020/10/28
			 *描述：获取新的朋友个数
			 *版本：1.0
			 */
			getnewfriendbadge(){
				this.axios({
					url:this.zuul+'/xyj-im/r/imChatHistory/getNewFriendCount?chatId='+sessionStorage.getItem('chatid'),
					method:'get',
				}).then(res => {
					this.badge = res.data;
					this.$emit('hasNewFriend')
				}).catch(err => {
					this.$message.error(err.message)
				})
			},
			/**
			 *张俊娜：2020/10/28
			 *描述：没有选择会话显示空白
			 *版本：1.0
			 */
			emptyShow(){
				this.isemptyShow = false
			},
			/**
			 *张俊娜：2020/10/28
			 *描述：显示新的好友页
			 *版本：1.0
			 */
			trigger(){
				this.isFriend = false;
			},
			/**
			 *张俊娜：2020/10/28
			 *描述：关闭聊天弹框
			 *版本：1.0
			 */
			close() {
				this.isemptyShow = true;
				this.sessionList = []
				this.$parent.chat = false
			},
			/**
			 *张俊娜：2019/12/3
			 *描述：监听是否按esc键
			 *版本：1.0
			 */
			checkFull() {
				//火狐浏览器
				var isFull = document.mozFullScreen||
				document.fullScreen ||
				//谷歌浏览器及Webkit内核浏览器
				document.webkitIsFullScreen ||
				document.webkitRequestFullScreen ||
				document.mozRequestFullScreen ||
				document.msFullscreenEnabled
				if(isFull === undefined) isFull = false;
		    return isFull;
			},
			/**
			 *张俊娜：2019/12/3
			 *描述：全屏退出全屏
			 *版本：1.0
			 */
			FullScreen(el) {
				if(this.isFullscreen) { //退出全屏
					if(document.exitFullscreen) {
						document.exitFullscreen()
					} else if(document.mozCancelFullScreen) {
						document.mozCancelFullScreen()
					} else if(document.webkitExitFullscreen) {
						document.webkitExitFullscreen()
					} else if(!document.msRequestFullscreen) {
						document.msExitFullscreen()
					}
				} else { //进入全屏
					if(el.requestFullscreen) {
						el.requestFullscreen()
					} else if(el.mozRequestFullScreen) {
						el.mozRequestFullScreen()
					} else if(el.webkitRequestFullscreen) {
						el.webkitRequestFullscreen();
					} else if(el.msRequestFullscreen) {
						this.isFullscreen = true;
						el.msRequestFullscreen()
					}
				}
			},
			/**
			 *张俊娜：2019/12/3
			 *描述：转换全屏
			 *版本：1.0
			 */
			toggleFullScreen(e) {
				this.isFullscreen = !this.isFullscreen;
				this.FullScreen(document.getElementById("chart"));
			},
			/**
			 *张俊娜：2019/12/11
			 *描述：用户修改
			 *版本：1.0
			 */
			edit(){
				if(this.file){			
					let fd = new FormData();
					fd.append("file",this.file.file);
					fd.append("type",this.fileType);
					this.axios({
					  hostUrl:this.zuul,
					  url:"/xyj-admin/w/FileUploadController/uploadFileType",
					  method:"post",
					  data:fd
					}).then(res =>{
						this.userChange(res)
					}).catch(err =>{
					  this.$message.error(err.message)
					})
				}else{
					this.userChange()
				}
			},
			userChange(res){
				if(res){
					this.form.headportrait = res;
				}
				delete this.form.userid
        this.$api.im.userSave(this.form).then(res => {
        	this.user.img = res.data.headportrait;
        	this.file = '';
        	this.dialogVisible = false;
        }).catch(err => {
        	this.$message.error(err.message)
        })
			},
			// 修改信息
			editDialog(){
				this.form.headportrait = store.fetch().user.img
				let query = {
					"querys": [
						{
							"hasInitValue": false,
							"operation": "EQUAL",
							"property": "id",
							"relation": "AND",
							"value": sessionStorage.getItem('chatid')
						}
					]
      	}
				this.$api.im.userQuery(query).then(res => {
					if(res.data.rows && res.data.rows.length>0){
						for(let key in res.data.rows[0]){
				      this.form[key] = res.data.rows[0][key]
						}
	        	this.user.id = res.data.rows[0].id
	        	this.user.img = res.data.rows[0].headportrait
	        	this.user.name = res.data.rows[0].usernickname
					}
        }).catch(err => {
        	this.$message.error(err.message)
        })
				this.dialogVisible = true
			},
			/**
			 *张俊娜：2019/12/11
			 *描述：上传图片
			 *版本：1.0
			 */
			handleAvatarSuccess(file) {
				this.file = file
        this.form.headportrait = URL.createObjectURL(file.file);
      },
      /**
			 *张俊娜：2019/12/11
			 *描述：显示新增好友
			 *版本：1.0
			 */
      showAdd(){
				let _this = this
				_this.badge = 0
				_this.isAdd = true;
				_this.isFriend = false;
				_this.isemptyShow = true;
				_this.showset = false;
				setTimeout(() => {
					_this.$refs.TheContact.$refs.friends.find()
					_this.receiveData = _this.$refs.chatsession.$refs.texts.receiveData
					_this.sessionList = []
				})
      },
      /**
			 *张俊娜：2019/12/12
			 *描述：获取用户好友
			 *版本：1.0
			 */
      FriendList(type){
      	let query = {
					"querys": [
						{
							"hasInitValue": true,
							"operation": "EQUAL",
							"property": "mainUserId",
							"relation": "AND",
							"value": sessionStorage.getItem('chatid')
						}
					]
				}
				// RelationshipQuery
				this.$api.im.queryImRelationship(query).then(res => {
					this.user.name = sessionStorage.getItem('user')
					if(res.data.rows && res.data.rows.length>0){
						this.userList = res.data.rows.map(element => {
							let obj = {};
							obj.id = element.id;
							obj.img = element.friendHeadportrait;
							obj.name = element.friendMemo?element.friendMemo:element.friendUserNickName;
							obj.conversationid = element.friendUserId;
							// 如果是当前会话人信息，未读为0
							obj.unRead = element.friendUserId == type ? 0 : element.unRead;
							obj.historyMsg = element.imHistory;
							return obj;
						});
						if(!(this.sessionList.length>0)){
							this.sessionList = res.data.rows.map(element => {
								let obj = {};
								obj.userId = element.id;
								obj.name = element.friendMemo?element.friendMemo:element.friendUserNickName;
								obj.conversationid = element.friendUserId;
								obj.unRead = element.unRead;
								obj.historyMsg = element.imHistory;
								obj.messages = [];
								obj.friendHeadportrait = element.friendHeadportrait;
								obj.fromUserNickName = this.form.usernickname;
								obj.fromUserLogo = this.form.headportrait;
								return obj;
							});
						}
					}
					if(type){
						this.$refs.chatsession.$refs.texts.getHistory(type)
					}
				}).catch(err => {
					if(type){
						this.$refs.chatsession.$refs.texts.getHistory(type)
					}
					this.$message.error(err)
				})
      },
      /**
			 *张俊娜：2019/12/12
			 *描述：好友列表
			 *版本：1.0
			 */
      getFriend(){
				this.showMemo = false
				this.showset = false
      	this.FriendList()
      	this.isAdd = false;this.isFriend = true;
			},
			// 会话上的未读标识在发送消息是清除掉当前聊天人的未读
			changebadge(id){
				this.userList.filter(x => x.id == id)[0].unRead = 0
			},
			beforeAvatarUploadPdf (file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension = testmsg === 'jpg'
        const extension2 = testmsg === 'png'
        const extension4 = testmsg === 'jpeg'
        if (!extension && !extension2) {
          this.$message({
            message: '头像修改仅支持 jpg, jpeg, png格式!',
            type: 'warning'
          })
          return false
        }
        return extension || extension2 || extension4
      }
		},
		/**
			 *张俊娜：2019/12/3
			 *描述：获取好友列表
			 *版本：1.0
			 */
		created() {
			this.getnewfriendbadge()
			this.FriendList()
			this.editDialog()
			this.dialogVisible = false
		},
		/**
			 *张俊娜：2019/12/3
			 *描述：窗口变化判断时候按esc键
			 *版本：1.0
			 */
		mounted() {
			store.init()
			let that = this;
			window.onresize = function() {
				if(!that.checkFull()) {
					that.isFullscreen = true;	
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	#chart {
  position: relative;
  margin: 20px auto;
  width: 800px;
  height: 600px;
  overflow: hidden;
  border-radius: 3px;
  text-align: left;
  line-height: normal;
}
.cardList{
	background-color: #2e3238;
}
.cardList :after{
	content: '';
	height: 0;
	line-height: 0;
	display: block;
	visibility: hidden;
	clear: both;
}
.sidebar,
.main,.cardList {
  height: 99.6%;
}
.m-card {
  padding: 12px;
	height: 96%;
}
.avatars,
.name {
  vertical-align: middle;
  vertical-align: middle;
}
.avatars {
	width: 40px;
	height: 40px;
  border-radius: 2px;
  border-radius: 2px;
}
.foot{
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: space-around;
	margin-top: 15px;
	text-align: center;
	height:30%;
	cursor: pointer;
	/deep/ .stylesize{
		display: block;
		margin: 0!important;
		font-size:20px;
		color: #999;
	}
	.footmessage{
		width: 28px;
		height: 26px;
	}
	.footpeople{
		width: 30px;
		height: 28px;
	}
	.footset{
		width: 30px;
		height: 28px;
	}
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px!important;
    text-align: center;
    margin-left: 0;
  }
  .avatarImg {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/vueChart/index.vue